import React, { ChangeEvent, FC, useState } from "react";
import { Input, InputProps } from "antd";
import classNames from "classnames";
import OnahInputError from "components/OnahInputError";
import { ReactComponent as Eye } from "assets/svgs/eye.svg";
import { ReactComponent as EyeDisabled } from "assets/svgs/eye-disabled.svg";
import OnahLabel from "components/OnahLabel";
import { ReactComponent as Lock } from "assets/svgs/Lock.svg";
import { formateAmount } from "helper";
import { getFormattedAmountValue } from "helper";

const { TextArea } = Input;

interface Props extends InputProps {
  label?: string;
  wrapperClassName?: string;
  labelClassName?: string;
  error?: string;
  type?: "input" | "password" | string | "textArea";
  format?: 'amount' | 'none'
  autoSize?: {
    minRows?: number;
    maxRows?: number;
  };
  defaultPasswordVisible?: boolean;
  suffixClassName?: string;
  info?: string;
  infoClassName?: string;
  hideLabelText?: boolean;
  labelWrapperClassName?: string;
}

const OnahInput: FC<Props> = ({
  label,
  name,
  className,
  wrapperClassName,
  labelClassName,
  error,
  type = "input",
  suffix,
  prefix,
  defaultPasswordVisible,
  onChange,
  maxLength,
  inputMode,
  suffixClassName,
  info,
  infoClassName,
  hideLabelText,
  labelWrapperClassName,
  format,
  ...props
}) => {
  const [passwordVisible, setPasswordVisible] = React.useState(
    type === "password" ? !!defaultPasswordVisible : true
  );
  const [focused, setFocused] = useState(false);

  const toggleVisibility = () => {
    setPasswordVisible((oldVisibility) => !oldVisibility);
  };

  const VisibilityElem = passwordVisible ? Eye : EyeDisabled;

  const Elem = type === "textArea" ? TextArea : Input;

  const getType = () => {
    if (type === "password" && !passwordVisible) {
      return "password";
    } else if (type === "password") {
      return "input";
    } else if (type === "date") {
      return "input";
    }
    return type;
  };

  const getInputType = () => {
    if (type === "date") {
      return "numeric";
    } else if (type === "email") {
      return "email";
    }
    return inputMode;
  };

  function formatDate(str: string, item: any, every: number) {
    for (let i = 0; i < str.length; i++) {
      if (!(i % (every + 1))) {
        str = str.substring(0, i) + item + str.substring(i);
      }
    }

    return str.substring(1);
  }

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (type === "date") {
      let value = e.target.value.replace(/\/+/g, "");
      // We use substring to add / to only the first part, every two characters
      const firstFourChars = formatDate(value.substring(0, 5), "/", 2);
      value = firstFourChars + value.substring(5, value.length);
      e.target.value = value;
    } else if (format === 'amount') {
      if( e.target.value && !isNaN(Number(getFormattedAmountValue(e.target.value)))) {
        e.target.value = formateAmount(e.target.value);
      }
    }
    onChange && onChange(e);
  };

  return (
    <div className={wrapperClassName}>
      <OnahLabel label={label} info={info} infoClassName={infoClassName}  className={labelClassName} hideText={hideLabelText} wrapperClassName={labelWrapperClassName}/>
      <Elem
        {...(props as any)}
        name={name}
        // type={type === 'password' && !passwordVisible ? 'password' : type === 'password' ? 'input' : type}
        type={getType()}
        placeholder={
          type === "date" ? "DD/MM/YYYY" : props.placeholder || label
        }
        className={classNames(
          className,
          "2xl:py-[14px] py-[12px] h-[48px] 2xl:h-[50px] 2xl:text-lg text-base",
          "px-3 font-sans rounded-lg outline-none focus:!outline-none text-black border-0",
          "[&>input]:placeholder:text-gray-placeholder [&>input]:placeholder:font-medium [&>input]:font-sans",
          "bg-gray-restingField [&>input]:bg-gray-restingField hover:!border-1 hover:!border-primary-ctaStroke",
          " focus:!border-primary-ctaStroke focus:!border font-semibold placeholder:text-gray-placeholder placeholder:font-medium",
          error ? "border-error-700 focus:border-error-700 border" : "",
          props.readOnly ?
            "!bg-white [&>input]:!bg-white !border !border-gray-inputFieldStroke" : ""
        )}
        inputMode={getInputType()}
        maxLength={type === "date" ? 10 : maxLength}
        onFocus={(e) => {
          props?.onFocus && props.onFocus(e as any);
          setFocused(true);
        }}
        onChange={handleOnChange}
        onBlur={(e) => {
          props?.onBlur && props.onBlur(e as any);
          setFocused(false);
        }}
        prefix={prefix && prefix}
        suffix={
          type === "password" ? (
            <div className={suffixClassName}>
              <VisibilityElem
                color={focused ? "black" : "#9E9EA6"}
                fontSize="12"
                className=""
                onClick={() => toggleVisibility()}
              />
              {suffix}
            </div>
          ) : (
            <div className={classNames(suffixClassName, 'flex items-center')}>
              {suffix}
              {props.readOnly && (
                <Lock />
              )}
            </div>
          )
        }
      />
      <OnahInputError error={error} showError={!!error} />
    </div>
  );
};

export default OnahInput;
